import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingIndicatorProps {
  message?: string;
  fullHeight?: boolean;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ 
  message = 'Carregando dados...', 
  fullHeight = false 
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: fullHeight ? '70vh' : 'auto',
      py: fullHeight ? 0 : 4
    }}>
      <CircularProgress size={fullHeight ? 60 : 40} thickness={4} color="secondary" />
      <Box sx={{ mt: 2, typography: 'body1', color: 'text.secondary' }}>
        {message}
      </Box>
    </Box>
  );
};

export default LoadingIndicator;
